/*
 * OFFSET: Cross-sell carousel (the "You'll need these" block).
 *
 * - Left/right arrow buttons scroll the card track (desktop + mobile).
 * - Arrows auto-disable when there's nothing more to scroll.
 * - Each card's "+" button adds that product to the cart and opens the cart
 *   drawer, replicating the theme's own ProductForm add flow (POST /cart/add.js
 *   with sections=variant-added, then dispatch the `variant:add` event the
 *   CartDrawer listens for). Defensive throughout — never breaks the page.
 */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function trackOf(carousel) {
    return carousel ? carousel.querySelector('[data-xsell-track]') : null;
  }

  function scrollByCards(carousel, direction) {
    var track = trackOf(carousel);
    if (!track) return;
    var card = track.querySelector('.offset-xsell__card');
    var gap = 10;
    var step = card ? (card.getBoundingClientRect().width + gap) * 2 : track.clientWidth * 0.8;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function refreshArrows(carousel) {
    var track = trackOf(carousel);
    if (!track) return;
    var prev = carousel.querySelector('[data-xsell-prev]');
    var next = carousel.querySelector('[data-xsell-next]');
    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    var scrollable = maxScroll > 1;
    if (prev) prev.disabled = !scrollable || track.scrollLeft <= 1;
    if (next) next.disabled = !scrollable || track.scrollLeft >= maxScroll;
  }

  async function addToCart(variantId, button) {
    if (!variantId) return;
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      // Let the cart popover/drawer + header cart count register the sections they
      // each need updated, exactly like the theme's own ProductForm does.
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));

      var fd = new FormData();
      fd.append('items[0][id]', variantId);
      fd.append('items[0][quantity]', 1);
      fd.append('sections', sections.join(','));
      fd.append('sections_url', root() + 'variants/' + variantId);

      var res = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      var json = await res.json();
      if (button) button.removeAttribute('aria-busy');
      if (!res.ok) return;

      // 1) Show the "Added to cart" confirmation immediately. It only needs the
      //    variant-added section, which the add response already returned — so we
      //    don't make the shopper wait on the second (cart.js) round-trip.
      document.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: json.items || [json], cart: { sections: json.sections } }
      }));

      // 2) Refresh the header cart count / cart contents in the background with the
      //    authoritative full cart, once it's fetched.
      fetch(root() + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        cart.sections = json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cart }
        }));
      }).catch(function () { /* count will catch up on next load */ });
    } catch (e) {
      if (button) button.removeAttribute('aria-busy');
    }
  }

  // Feature-strip "Watch it in action" video: swap the poster tile for an embed.
  function videoEmbedUrl(url) {
    if (!url) return null;
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }
  function playFeatureVideo(tile) {
    var embed = videoEmbedUrl(tile.getAttribute('data-fstrip-video'));
    if (!embed) { window.open(tile.getAttribute('data-fstrip-video'), '_blank', 'noopener'); return; }
    var frame = document.createElement('iframe');
    frame.src = embed;
    frame.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('title', tile.getAttribute('aria-label') || 'Video');
    tile.replaceWith(frame);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var prev = e.target.closest('[data-xsell-prev]');
    if (prev) { scrollByCards(prev.closest('[data-offset-xsell]'), -1); return; }
    var next = e.target.closest('[data-xsell-next]');
    if (next) { scrollByCards(next.closest('[data-offset-xsell]'), 1); return; }
    var add = e.target.closest('[data-xsell-add]');
    if (add && !add.disabled) { addToCart(add.getAttribute('data-variant-id'), add); return; }
    var video = e.target.closest('[data-fstrip-video]');
    if (video) { playFeatureVideo(video); }
  });

  function initAll() {
    var carousels = document.querySelectorAll('[data-offset-xsell]');
    for (var i = 0; i < carousels.length; i++) {
      var c = carousels[i];
      var track = trackOf(c);
      if (track && !track.__xsellBound) {
        track.__xsellBound = true;
        (function (carousel, tr) {
          tr.addEventListener('scroll', function () { refreshArrows(carousel); }, { passive: true });
        })(c, track);
      }
      refreshArrows(c);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('resize', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
